import type { TealiumEventData } from 'src/types/trackingData';

import { EVENT_NAME_HELP_TEXT_EXPAND, EVENT_NAME_INTERACTION } from '.';

const LOCATION_CLICKED_LINK_NAME = 'ecaja-location-clicked';
export const locationClicked: TealiumEventData = {
  linkName: LOCATION_CLICKED_LINK_NAME,
  eventName: [LOCATION_CLICKED_LINK_NAME, EVENT_NAME_INTERACTION],
  objectInteraction: 'location',
};

const LOCATION_TOOLTIP = 'ecaja-location-tooltip-expanded';
export const locationTooltipExpanded: TealiumEventData = {
  linkName: LOCATION_TOOLTIP,
  eventName: [LOCATION_TOOLTIP, EVENT_NAME_HELP_TEXT_EXPAND],
  objectInteraction: 'location-help',
};
